import React, { useEffect, useRef, useState } from 'react';
import Globe from 'react-globe.gl';
import * as THREE from 'three';
import '../assets/css/world.css'
import '../assets/css/location.css'
import india from '../assets/images/icons/india.png'
import uae from '../assets/images/icons/united-arab-emirates.png'
import bahrain from '../assets/images/icons/bahrain.png'
import surat from '../assets/images/city/surat.jpg'
import delhi from '../assets/images/city/delhi.jpg'
import ahmedabad from '../assets/images/city/ahmedabad.jpg'
import mumbai from '../assets/images/city/mumbai.jpg'
import backIcon from "../assets/images/back_icon.png";
import World2 from './World2';

const World = () => {
  const globeEl = useRef();
  const [activeCountry, setActiveCountry] = useState("india");
  const [activeCity, setActiveCity] = useState("");
  const [exploreCountry, setExploreCountry] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [selectedArea, setSelectedArea] = useState("");
  const [showCountryList, setShowCountryList] = useState(false);
  const [cloudOpacity, setCloudOpacity] = useState(0);
  const [cloudMesh, setCloudMesh] = useState(null);
  const countryListArr = [
    { lat: 24.4457, lng: 79.1817, city: "India", name: "India", altitude: 0.02 },
    { lat: 25.1263, lng: 55.3064, city: "Dubai", name: "Dubai", altitude: 0.02 },
    { lat: 26.0710, lng: 50.5421, city: "Bahrain", name: "Bahrain", altitude: 0.02 },
  ]
  const [locations, setLocations] = useState(countryListArr);

  const cityLocations = {
    india: [
      { lat: 28.6139, lng: 77.2090, city: "New Delhi", name: "New Delhi", altitude: 0.02, icon: delhi, projectCount: "10+ Developments" },
      { lat: 23.02893, lng: 72.5716, city: "Ahmedabad", name: "Ahmedabad", altitude: 0.02, icon: ahmedabad, projectCount: "5+ Developments" },
      { lat: 21.1683, lng: 72.82775, city: "Surat", name: "Surat", altitude: 0.02, icon: surat, projectCount: "15+ Developments" },
      { lat: 19.0760, lng: 72.8777, city: "Mumbai", name: "Mumbai", altitude: 0.02, icon: mumbai, projectCount: "47+ Developments" },
    ],
    dubai: [
      { lat: 25.276987, lng: 55.296249, city: "Dubai City", name: "Dubai City", altitude: 0.02 }
    ],
    bahrain: [
      { lat: 26.2285, lng: 50.5860, city: "Manama", name: "Manama", altitude: 0.02 }
    ]
  };


  useEffect(() => {
    if (globeEl.current) {
      globeEl.current.controls().autoRotate = false;
      globeEl.current.controls().autoRotateSpeed = 0.3;
      if (window.innerWidth <= 767) {
        globeEl.current.pointOfView({ lat: 20.59, lng: 78.96, altitude: 3.5 }, 0);
      } else {
        globeEl.current.pointOfView({ lat: 20.59, lng: 78.96, altitude: 1.5 }, 0);
      }
    }
  }, []);

  useEffect(() => {
    if (globeEl.current) {
      let locations;
      if (window.innerWidth <= 767) {
        locations = {
          india: { lat: 20.59, lng: 78.96, altitude: 3.5 },
          dubai: { lat: 23, lng: 55, altitude: 3.5 },
          bahrain: { lat: 26, lng: 50, altitude: 3.5 },
        };
        globeEl.current.pointOfView(locations[activeCountry], 1500);
      } else {
        locations = {
          india: { lat: 20.59, lng: 78.96, altitude: 1.5 },
          dubai: { lat: 23, lng: 55, altitude: 1.5 },
          bahrain: { lat: 26, lng: 50, altitude: 1.5 },
        };
        globeEl.current.pointOfView(locations[activeCountry], 1500);
      }
    }
  }, [activeCountry]);

  const handleExplore = (country) => {
    setExploreCountry(country);
  };
  const createClouds = () => {
    const cloudTexture = new THREE.TextureLoader().load('/clouds.png');
    cloudTexture.wrapS = THREE.RepeatWrapping;
    cloudTexture.wrapT = THREE.RepeatWrapping;

    const cloudMaterial = new THREE.MeshPhongMaterial({
      map: cloudTexture,
      transparent: true,
      opacity: 1,
      depthWrite: false,
    });

    const cloudGeometry = new THREE.SphereGeometry(globeEl.current.getGlobeRadius() * 1.05, 64, 64);
    const cloudSphere = new THREE.Mesh(cloudGeometry, cloudMaterial);

    globeEl.current.scene().add(cloudSphere);
    setCloudMesh(cloudSphere);

    let opacity = 0.5;
    let rotationSpeed = 0.002;
    let textureOffset = 0;

    // Animate the clouds like a storm
    const animateClouds = () => {
      if (cloudSphere) {
        cloudSphere.rotation.y += rotationSpeed;
        textureOffset += 0.002;
        cloudSphere.material.map.offset.set(textureOffset, textureOffset * 0.5);
      }

      if (opacity > 0) {
        opacity -= 0.005;
        cloudSphere.material.opacity = opacity;
        requestAnimationFrame(animateClouds);
      } else {
        globeEl.current.scene().remove(cloudSphere);
        setLocations(cityLocations[exploreCountry] || []);
        setShowCountryList(true);
      }
    };

    animateClouds();
  };

  useEffect(() => {
    if (exploreCountry) {
      createClouds();
    }
  }, [exploreCountry]);

  const handleBack = () => {

    if (selectedCity) {
      setSelectedCity("");
    } else {
      setExploreCountry(""); // Exit city view
      setLocations(countryListArr);
      setShowCountryList(false);
    }
  };

  const handleExploreCity = (city) => {
    setSelectedCity(city);
  }

  return (
    <div style={{ position: "relative" }}>
      {
        <div style={{ display: (selectedCity === "" ? "block" : "none") }}>
          <Globe
            ref={globeEl}
            globeImageUrl="//cdn.jsdelivr.net/npm/three-globe/example/img/earth-blue-marble.jpg"
            bumpImageUrl="//cdn.jsdelivr.net/npm/three-globe/example/img/earth-topology.png"
            objectsData={locations}
            objectLat="lat"
            objectLng="lng"
            objectAltitude="altitude"
            objectLabel="name"
            objectThreeObject={(d) => {
              let material;
              let sprite;
              switch (d.name) {
                case "India":
                  material = new THREE.SpriteMaterial({
                    map: new THREE.TextureLoader().load('/india.png'),
                  });
                  sprite = new THREE.Sprite(material);
                  sprite.scale.set(5, 5, 1);
                  return sprite;
                case "Dubai":
                  material = new THREE.SpriteMaterial({
                    map: new THREE.TextureLoader().load('/united-arab-emirates.png'),
                  });
                  sprite = new THREE.Sprite(material);
                  sprite.scale.set(5, 5, 1);
                  return sprite;
                case "Bahrain":
                  material = new THREE.SpriteMaterial({
                    map: new THREE.TextureLoader().load('/bahrain.png'),
                  });
                  sprite = new THREE.Sprite(material);
                  sprite.scale.set(5, 5, 1);
                  return sprite;
                default:
                  material = new THREE.SpriteMaterial({
                    map: new THREE.TextureLoader().load('/locationIcon.png'),
                  });
                  sprite = new THREE.Sprite(material);
                  sprite.scale.set(2, 2, 1);
                  return sprite;
              }


            }}
          />

          <div
            className="cloud-overlay"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "url('/clouds.png') center center / cover no-repeat",
              opacity: cloudOpacity,
              transition: "opacity 2s ease-in-out",
              pointerEvents: "none",
            }}
          ></div>
        </div>
      }
      {
        !exploreCountry ?
          <div className={`country_list_cards ${activeCountry !== "" && 'show'}`}>
            <div className={`country_list_card ${activeCountry === 'india' && 'active'}`}>
              <div className='d-flex' onClick={() => setActiveCountry("india")}>
                <img src={india} alt="India" className='country-image' />
                <div className='country_text_cointainer'>
                  <span className='country_name'>India</span>
                  <span className='country_project_count'>80+ Developments</span>
                </div>
              </div>
              <button className='country_explore_btn' onClick={() => handleExplore("india")}>Explore</button>
            </div>
            <div className={`country_list_card ml-20 ${activeCountry === 'dubai' && 'active'}`}>
              <div className='d-flex' onClick={() => setActiveCountry("dubai")}>
                <img src={uae} alt="UAE" className='country-image' />
                <div className='country_text_cointainer'>
                  <span className='country_name'>United Arab Emirates</span>
                  <span className='country_project_count'>1+ Developments</span>
                </div>
              </div>
              <button className='country_explore_btn' onClick={() => handleExplore("dubai")}>Explore</button>
            </div>
            <div className={`country_list_card ml-20 ${activeCountry === 'bahrain' && 'active'}`}>
              <div className='d-flex' onClick={() => setActiveCountry("bahrain")}>
                <img src={bahrain} alt="Bahrain" className='country-image' />
                <div className='country_text_cointainer'>
                  <span className='country_name'>Bahrain</span>
                  <span className='country_project_count'>2+ Developments</span>
                </div>
              </div>
              <button className='country_explore_btn' onClick={() => handleExplore("bahrain")}>Explore</button>
            </div>
          </div> :
          selectedCity == "" &&
          <div className={`country_list_cards ${activeCountry !== "" && 'show'}`}>
            {cityLocations[exploreCountry].map((city, index) => (
              <div className={`country_list_card city ${activeCity === city.name && 'active'} ${index !== 0 && 'ml-20'}`}>
                <div className='d-flex' onClick={() => setActiveCity(city.name)}>
                  <img src={city.icon} alt="UAE" className='country-image' />
                  <div className='country_text_cointainer'>
                    <span className='country_name'>{city.name}</span>
                    <span className='country_project_count'>{city.projectCount}</span>
                  </div>
                </div>
                <button className='country_explore_btn' onClick={() => handleExploreCity(city.name)}>Explore</button>
              </div>
            ))}
          </div>
      }
      {
        showCountryList &&
        < div className='back-btn-container show'>
          <button className='back-btn show' onClick={handleBack}><img src={backIcon} alt="back-btn" /></button>
        </div>
      }
      {
        selectedCity === "Mumbai" &&
        <div>
          <World2 />
        </div>
      }
    </div >
  );
};

export default World;